import { render, staticRenderFns } from "./ItsStockFruitRepackInBound.vue?vue&type=template&id=0f96ce14&scoped=true&"
import script from "./ItsStockFruitRepackInBound.vue?vue&type=script&lang=js&"
export * from "./ItsStockFruitRepackInBound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f96ce14",
  null
  
)

export default component.exports